module.exports = __webpack_public_path__ + "f4958e916c846d1aa536b8ec9e9744c3.svg";